import styled from 'styled-components'

export const DetailsWrapperStyled = styled.div.attrs((props) => ({}))`
    text-align: left;
`
